import { render, staticRenderFns } from "./QueryLightOpenRate.vue?vue&type=template&id=28fd4c89&scoped=true"
import script from "./QueryLightOpenRate.vue?vue&type=script&lang=js"
export * from "./QueryLightOpenRate.vue?vue&type=script&lang=js"
import style0 from "./QueryLightOpenRate.vue?vue&type=style&index=0&id=28fd4c89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fd4c89",
  null
  
)

export default component.exports